<template>
  <el-card v-loading="isLoading">
    <div scope="header">
      <span class="cadastro-title">Analítico Período</span>
      <div class="pull-right">
        <indicador-periodo-filter @filtroAplicado="filter" @filtroExcel="getExcel"></indicador-periodo-filter>
      </div>
      <hr/>
    </div>
    <div v-if="periodo" class="table-responsive">
      <table class="table table-hover">
        <tbody>
        <tr class="title painel-sub-header">
          <td colspan="2" class="collum-first">
            <div class="d-flex flex-row">
              <div class="text-left pl-2">
                {{centro.nome}} - {{centro.user_name}}
              </div>
            </div>
          </td>
          <template v-for="competencia in competencias">
            <td class="cell-competencia cell-competencia-nota"
                v-bind:class="style_bate_meta(competencia.bateu , competencia.nota)"
                v-bind:key="competencia.id">
              <div class="d-flex flex-column align-items-stretch">
                {{ format_value(competencia.nota) }}
              </div>
            </td>
          </template>
        </tr>
        <tr class="title painel-sub-header ">
          <td>
            <span class="text-left pl-2">Indicador</span>
          </td>
          <td class="indicador-requisito">
            <div class="d-flex">
              <i class="fa fa-arrow-up pull-right" aria-hidden="true"></i>
              <i class="fa fa-arrow-down pull-left" aria-hidden="true"></i>
            </div>
          </td>
          <td class="cell-value" v-for="competencia in competencias">
            <span class="text-capitalize font-weight-bold">{{competencia.label}}</span>
          </td>
        </tr>

        <template v-for="indicador in indicadores">

          <indicador-line @metaSelected="handleMetaSelected" :showGraph.sync="showGraph" :node="indicador" :nivel="1"
                          :showini="true"></indicador-line>

          <template v-for="child in indicador.childrens">

            <indicador-line @metaSelected="handleMetaSelected" :showGraph.sync="showGraph" :node="child" :nivel="2"
                            :parent_id="indicador.id"
                            :showini="false">
            </indicador-line>
          </template>
        </template>
        </tbody>
      </table>

      <detail-meta :visible.sync="showDetailMeta" :meta="metaSelected"></detail-meta>
      <grafico-column-line :visible.sync="showGraph"
                           :title="this.indicadorSelectedGraph.nome"
                           :axiox="{title:'Competencias' , labels: this.indicadorSelectedGraph.label}"
                           :axioy="{title:'Realizado'}"
                           :series="{  column:{ name:'Realizado' , data:  this.indicadorSelectedGraph.column} ,
                              spline:{ name:'Meta' ,data :  this.indicadorSelectedGraph.spline} }"/>
    </div>
  </el-card>


</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import {MessageBox} from 'element-ui'
  import * as utils from '@/domain/utils'
  import IndicadorLine from './IndicadorLine'
  import GraficoColumnLine from '../Shared/GraficoColumnLine'
  import {colorByMeta} from '@/domain/utils'
  import DetailMeta from '../Shared/DatailMeta'
  import IndicadorPeriodoFilter from "./IndicadorPeriodoFilter";
  import FileSaver from 'file-saver';

  export default {
    name: "painel",
    components: {IndicadorPeriodoFilter, IndicadorLine, GraficoColumnLine, DetailMeta},
    data() {
      return {
        showDetailMeta: false,
        metaSelected: {},
        showGraph: false,
        isLoading: false,
        periodoId: 0
      }
    },
    computed: {
      centro() {
        return this.periodo.centrocusto
      },
      competencias() {
        return this.periodo.competencias
      },
      indicadores() {
        return this.periodo.indicadores
      },
      ...mapState(['anos', 'anoSelected', 'centroCustoList']),
      ...mapState('User', ['user']),
      ...mapState('Relatorio', ['periodo', 'indicadorSelectedId']),
      indicadorSelectedGraph() {
        let indicador = collect(this.indicadores).firstWhere('id', this.indicadorSelectedId)
        if (!_.isObjectLike(indicador)) {
          return {
            nome: "",
            label: {},
            column: {},
            spline: {}
          }
        }

        let dados = {}
        let competencias = indicador.competencias.filter(o => o.apurado && !o.acumula)
        let competenciasIds = _.map(competencias, 'id')
        let label = this.competencias.filter(o => {
          return competenciasIds.includes(o.mes)
        })
        dados.nome = indicador.nome
        dados.label = _.map(label, 'label')
        dados.column = _.map(competencias, (o) => ({y: o.realizado, color: colorByMeta(o.bateu)}))
        dados.spline = _.map(competencias, (o) => ({y: o.meta}))
        return dados
      }
    },
    methods:
      {
        ...utils,
        ...mapActions('Relatorio', ['setPeriodo']),
        async filter(event) {
          try {
            this.isLoading = true
            await this.setPeriodo({...event})
          } catch (e) {
            console.log(e)
          } finally {
            this.isLoading = false
          }

        },
        handleMetaSelected(payload) {
          this.metaSelected = {...payload.meta}
          this.showDetailMeta = true
        },
        async getExcel(payload) {
          try {
            this.isLoading = true
            //painel/{periodo}/centrocusto/{centroCusto}/analitico/pdf
            const {data} = await axios.get(`${process.env.API_URI_PATH}/painel/${payload.ano}/centrocusto/${payload.centroCusto}/analitico/pdf`, {responseType: 'blob'});
            FileSaver.saveAs(new Blob([data]), 'analitico.pdf');
          } catch (e) {
            console.log(e);
          } finally {
            this.isLoading = false;
          }
        }
      },
    mounted() {

      this.filter()

    }
  }
</script>

<style src="@/assets/css/relatorio.css" scoped></style>



// WEBPACK FOOTER //
// src/features/Dashboard/Components/Periodo/index.vue